import React from 'react';
import Select from './Select';

interface User {
  id: string;
  name: string;
  email?: string;
  photoUrl?: string;
}

interface UserSelectorProps {
  users: User[];
  value: string;
  onChange: (userId: string) => void;
  placeholder?: string;
  error?: string;
  disabled?: boolean;
  className?: string;
  dropdownDirection?: 'down' | 'up';
}

const UserSelector: React.FC<UserSelectorProps> = ({
  users,
  value,
  onChange,
  placeholder = 'Выберите пользователя',
  error,
  disabled = false,
  className = '',
  dropdownDirection = 'down',
}) => {
  return (
    <Select<User>
      items={users}
      value={value || null}
      onChange={(id) => onChange(id)}
      getId={(u) => u.id}
      getPrimary={(u) => u.name}
      getSecondary={(u) => u.email}
      getAvatarText={(u) => u.name}
      getAvatarUrl={(u) => u.photoUrl}
      searchAccessors={[(u) => u.name, (u) => u.email]}
      placeholder={placeholder}
      emptyText={'Пользователи не найдены'}
      error={error}
      disabled={disabled}
      className={className}
      dropdownDirection={dropdownDirection}
    />
  );
};

export default React.memo(UserSelector);
